import { FlowEntry, FlowProgressWithSteps } from 'utils/FlowProvider/types'
import { investingPageVisited } from 'utils/FlowProvider/utils'

export const NavSteps: (entry: FlowEntry, props: any) => FlowProgressWithSteps = (
  entry,
  { visitedPages, history },
) => {
  if (!entry) {
    history.push('/', { pageNotFound: true })
  }

  const steps = [
    { label: 'Account' },
    { label: 'Round-Ups' },
    { label: 'Personal' },
    { label: 'Investments' },
  ]

  if (investingPageVisited(visitedPages)) {
    entry.progress = {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    }
  }

  return { ...entry.progress, steps }
}
